import { createSelector } from 'reselect';
import { getLanguage } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';

// Move off any when baseContentModelSelectors is migrated to immer

export const getLanguages = basicSelector(state => state.languages);
export const getSupportedLanguages = createSelector([getLanguages], languages => languages.supportedLanguages);
export const getRenderLanguage = createSelector([getLanguages], languages => languages.renderLanguage);
export const getHasLanguage = createSelector([getLanguage], language => !!language);